<template>
  <el-cascader
    :placeholder="placeholder"
    clearable
    @change="changeDepartMethod"
    :props="props"
    v-model="currentSel"
    ref="cascader"
    popper-class="cascader-tree"
    collapse-tags
  ></el-cascader>
</template>

<script>
// 接口api
import { getDepartmentList } from 'api/common'
import Vue from 'vue'
const placeholder = Vue.prototype.$t('221')

export default {
  name: 'department',
  props: {
    placeholder: {
      type: String,
      default: placeholder
    },
    mprop: {
      type: Object,
      default: () => {}
    },
    change: {
      type: Function,
      default: () => () => {}
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const self = this
    return {
      department_id: 1,
      currentSel: '',
      props: {
        lazy: true,
        leaf: 'is_sub_department',
        value: 'department_id',
        label: 'department_name',
        multiple: this.multiple,
        lazyLoad(node, resolve) {
          getDepartmentList({
            department_id: node && node.data && node.data.department_id ? node.data.department_id : self.department_id
          }).then(res => {
            const data = res.data
            const arr = data.map(item => {
              item.is_sub_department = !item.is_sub_department
              return item
            })
            resolve(arr)
          })
        }
      }
    }
  },
  created() {
    this.props = {
      ...this.props,
      ...this.mprop
    }
  },
  methods: {
    // 注册事件返回
    changeDepartMethod(val) {
      let selectArr = []
      const obj = this.$refs.cascader.getCheckedNodes(true)[0]
      const deep = (data = {}, arr = []) => {
        data.data && arr.unshift(data.data)
        if (data.parent) deep(data.parent, arr)
        return arr
      }
      if (this.multiple) {
        let arr = JSON.parse(JSON.stringify(val))
        arr = arr.toString().split(',')
        selectArr = Array.from(new Set(arr))
      }
      // selectArr在多选数组时可用
      this.change(deep(obj), val, selectArr)
    }
  }
}
</script>
